import { useSearchParams } from 'react-router';
import { Box } from '@chakra-ui/react';
import Pagination from '@components/Pagination';
import { SIDEBAR_WIDTH } from '@App/Dashboard/utils/sizes';

type Props = {
  total: number,
  children: React.ReactNode,
};

const PaginationRouterContainer = ({
  total, children,
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageParam = Number(searchParams.get('page')) || 1;
  const limitParam = Number(searchParams.get('limit')) || 10;

  const defaultPage = pageParam < 1 ? 1 : pageParam;
  const defaultLimit = (limitParam > 100 || limitParam < 1) ? 10 : limitParam;

  const handleWithPaginationChange = (page: number, limit: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page.toString());
    newParams.set('limit', limit.toString());
    setSearchParams(newParams);
  };

  return (
    <Box pb={24}>
      {children}

      <Box
        position="fixed"
        bottom={0}
        left={{ base: 0, md: SIDEBAR_WIDTH }}
        right={0}
        bg="bg"
        borderTop="1px solid"
        borderColor="border.muted"
        px={{ base: 4, md: 6 }}
        zIndex={10}
      >
        <Pagination
          limit={defaultLimit}
          total={total}
          page={defaultPage}
          onPaginationChange={handleWithPaginationChange}
        />
      </Box>
    </Box>
  );
};

export default PaginationRouterContainer;
